<template>
  <div>
      <web-socket-core :sock="sock"/>
  </div>
</template>
<script>
  import bus from '@/utils/vueBus.js'
  import { timeFormat } from '@/utils'
  import webSocketCore from './webSocketCore'
  export default {
    components: { webSocketCore },
    data () {
      return {
        timer: 1,
        sock: null,
        intervalId: null,
        sessionId: null,
        tt: null,
        lockReconnect: false,
        ts: null,
        sessionTypeIndex: 1, // 会话类型
        sessionSearch: '', // 搜索的会话
      }
    },
    computed: {
      token () {
        return this.$store.state.auth.token// 需要监听的token
      },
      tenancyId () {
        return this.$store.state.auth.tenancyId// 需要监听的tenancyId
      }
    },
    filters: {
      timeFilter (val) {
        return timeFormat(val)
      }
    },
    watch: {
      timer (val, old) {
        let text = JSON.stringify({
          code: 10001,
          id: old
        })
        if (val !== 1) {
          this.sock.send(text)
        }
      },
      tenancyId (val) {
        // 监听租户ID，当租户ID变化时，才去连接websock
        if (val) {
          if (this.sock) {
            this.sock.close()
            this.sock = null
          }
          // 切换租户的时候需要清空缓存
          this.$store.dispatch('setWxbClearOnlineCache')
          this.openWebsocket()
        }
      },
      token(val) {
        if (val === null) {
          this.sock.close()
          this.sock = null
        }
      }
    },
    mounted () {
      // 连接websocket 需要同时满足token和tenancyId 非空 在页面重新刷新，进来加载时，这时候的tenancyId和token是不变的，但是因为websocket已经断开了，因此需要重连
      console.log('ddde33:', this.$store.state.auth)
        if (this.$store.state.auth.tenancyId && this.$store.state.auth.token) {
          console.log('333222')
        this.openWebsocket()
        //this.initData()
      }
      bus.$on('sessionId', (value) => {
        this.sessionId = value.id
      })
      // 记录会话列表究竟是点击了，我的，别人给我，分给他人
      bus.$off('sessionTypeIndex')
      bus.$on('sessionTypeIndex', (val) => {
        this.sessionTypeIndex = val
      })
      bus.$off('sessionSearch')
      bus.$on('sessionSearch', (val) => {
        this.sessionSearch = val
      })
    },
    methods: {
      // 定时刷新数据函数
      dataRefreh (value) {
        // 计时器正在进行中，退出函数
        if (this.intervalId != null) {
          return
        }
        // 计时器为空，操作
        this.intervalId = setInterval(() => {
          let text = JSON.stringify({
            code: 20005,
            id: new Date().getTime(),
            data: {
              wId: value
            }
          })
          this.sock.send(text) //加载数据函数
        }, 5000)
      },
      // 停止定时器
      clear () {
        clearInterval(this.intervalId) //清除计时器
        this.intervalId = null //设置为null
      },
      tokenVail () {
        this.$http.get(`/scrm/v1/user-info/p/isTokenLose`)
            .then(res => {
              const { code } = res
              if (code === 1) {
                if (res.data === false) {
                  this.$Message.info('登录过期，请重新登录')
                  this.$router.push({ path: '/login' })
                }
              }
            }).catch(err => {
        })
      },
      // 打开websocket
      openWebsocket () {
        try {
          // 检查token是否过期 && this.sock == null
          this.tokenVail()
          console.log('重连中。。。。', document.location.protocol, this.sock)
          if (this.$store.state.auth.tenancyId !== null && this.$store.state.auth.token !== null && (this.sock == null || this.sock.readyState !== 1)) {
            if (document.location.protocol === 'http:') {
              this.sock = new WebSocket(process.env.VUE_APP_WEB_SOCKET + `/ws/scrm/${this.$store.state.auth.tenancyId}/${this.$store.state.auth.token}`)
                console.log('连上。。。。', document.location.protocol, this.sock, new Date())
            } else {
              this.sock = new WebSocket(process.env.VUE_APP_WEB_SOCKET_S + `/ws/scrm/${this.$store.state.auth.tenancyId}/${this.$store.state.auth.token}`)
                console.log('连上。。。。', document.location.protocol, this.sock, new Date())
            }
            this.webSocketInit(this) // 初始化webSocket连接函数
          }
        } catch (e) {
          // 失败 重连
          this.webSocketReconnect(this)
        }
      },
      webSocketInit (_this) {
        // 连接关闭函数
        this.sock.onclose = function() {
          clearInterval(_this.ts) // 清除timer，避免timer加1导致自动发送websocket消息
          _this.timer = 1 //设置为1
          _this.webSocketReconnect(_this) // 如果连接关闭则重连
        }
        // 连接错误函数
        this.sock.onerror = function() {
          clearInterval(_this.ts) // 清除timer，避免timer加1导致自动发送websocket消息
          _this.timer = 1 //设置为1
          _this.webSocketReconnect(_this) //如果连接错误则重连
        }
        // 连接建立,发送信息
        this.sock.onopen = function() {
          //心跳检测启动
          _this.ts && clearInterval(_this.ts)
          _this.timer = 1
          _this.ts = setInterval(() => {
            _this.timer++
          }, 25000)
        }
        // 业务订阅成功后接受服务端推送消息
        this.sock.onmessage = (event) => {
          const res = JSON.parse(event.data)
          console.log(`event=======`, res.code, res, event)
        }
      },
      webSocketReconnect (_this) {
        this.tt && clearTimeout(this.tt)
        this.tt = setTimeout(function() {
          _this.openWebsocket()
        }, 3000)
      }
    },
  }
</script>
<style lang="less" scoped>

</style>
